import React from "react";

function NotAvailable() {
  return (
    <div className="bg-black text-white text-2xl font-bold flex justify-center mt-16">
      No TV Shows avaialble for the selected genre. Please select a different
      genre.
    </div>
  );
}

export default NotAvailable;
